export default function SignupBox () {
	const ELEMENTS = document.querySelectorAll('.mtt-single-content__signup-box')
	let hasRun = false;
	if (ELEMENTS.length > 0) {
		for (let i = 0; i < ELEMENTS.length; i++) {
			const EL = ELEMENTS[i]
			const LOCATIONS = EL.querySelector('.mtt-single-content__signup-box--locations')
			const TEXT_CONTAINER = EL.querySelector('.mtt-single-content__signup-box--dates-container--text-container')
			const FORM_CONTAINER = EL.querySelector('.mtt-single-content__signup-box--dates-container--form-container')
			const BUTTON = EL.querySelector('.button')
			const RADIOS = EL.querySelectorAll('input[type=radio][name="location"]');
			RADIOS.forEach(radio => radio.addEventListener('change', () => {
				const ID = radio.getAttribute('data-id')
				EL.querySelector('.mtt-single-content__signup-box--dates.active').classList.remove('active')
				EL.querySelector('.mtt-single-content__signup-box--dates[data-id="'+ID+'"]').classList.add('active')
				EL.querySelector('.mtt-single-content__signup-box--dates.active').querySelector('label:first-child input').checked = true
				const SCRIPT = document.querySelector('.form-script')
				if(SCRIPT){
					SCRIPT.remove()
				}
				FORM_CONTAINER.innerHTML = ''
				TEXT_CONTAINER.classList.remove('hidden')
			}));
			BUTTON.addEventListener('click', function () {
				if (LOCATIONS) {
					LOCATIONS.classList.add('disable')
				}
				const FORM_HTML = getCheckedRadioValue('date')
				if(FORM_HTML){
					TEXT_CONTAINER.classList.add('hidden')
					setInnerHTML(FORM_CONTAINER, FORM_HTML)
				}else {
					alert('Der er sket en fejl, kontakt os venligst')
				}
			})
		}
	}

	function getCheckedRadioValue(name) {
		var elements = document.getElementsByName(name);

		for (var i=0, len=elements.length; i<len; ++i)
			if (elements[i].checked) return elements[i].getAttribute('data-form');
	}

	var setInnerHTML = function(elm, html) {
		elm.innerHTML = html;
		let hasScript = false;
		if(!hasRun){
			Array.from(elm.querySelectorAll("script")).forEach( oldScript => {
				const newScript = document.createElement("script");
				newScript.className = 'form-script'
				Array.from(oldScript.attributes)
					.forEach( attr => newScript.setAttribute(attr.name, attr.value) );
				newScript.appendChild(document.createTextNode(oldScript.innerHTML));
				oldScript.parentNode.replaceChild(newScript, oldScript);
				hasScript = true
			});
			hasRun = true
		}
		if(hasScript){
			elm.innerHTML += "<script>MsCrmMkt.MsCrmFormLoader.on('formSubmit', function(event) { ga( 'send', 'event', 'Kontaktformular udfyldelse', 'submit', 'Kontaktformular udfyldelse' ); dataLayer.push({'event': 'Kontaktformular udfyldelse', 'formPageId': event.formPageId, 'formPageURL': '"+window.location.href+"'}); }); </script>";
		}
	}
}